export default __webpack_public_path__ + "assets/icons/home_del.4af8138d.svg";